// @flow
import { createRequestActionNames } from 'helpers/redux/createRequestActionNames'

export const HOLIDAYS_LIST = createRequestActionNames('HOLIDAYS_LIST', ['GET', 'POST'])
export const HOLIDAY_LIST_SET_PENDING = 'HOLIDAY_LIST_SET_PENDING'
